module.exports = __webpack_public_path__ + "img/mail-logo.e9a28f1e.svg";